import script from "./text-editor.vue?vue&type=script&setup=true&lang=ts"
export * from "./text-editor.vue?vue&type=script&setup=true&lang=ts"

import "./text-editor.vue?vue&type=style&index=0&id=3907eb98&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3907eb98"]])

export default __exports__